(function () {
  var section = document.querySelector('[data-related]');
  if (!section) return;
  var url = section.getAttribute('data-url');
  if (!url) return;

  fetch(url)
    .then(function (res) { return res.text(); })
    .then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-related] .related__grid');
      var current = section.querySelector('.related__grid');
      if (fresh && current) {
        current.replaceWith(fresh);
      } else if (fresh) {
        var head = section.querySelector('.related__head');
        if (head) head.insertAdjacentElement('afterend', fresh);
      }
    })
    .catch(function () {});
})();
